<div
  bsModal
  #shareSheetModal="bs-modal"
  [config]="{ show: false }"
  [rlTrapFocus]="focusTrapConfig"
  (onHidden)="onShareSheetHidden()"
  class="modal fade qa-sharesheet-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="share-modal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2
          class="modal-title"
          id="share-modal"
          i18n="@@listItem-shareModal-heading-shareItem"
        >
          Share item
        </h2>
      </div>
      <div class="modal-body">
        <label
          class="form-label"
          for="item-url"
          i18n="@@shareSheet-label-copyLink"
          >Copy the link below:</label
        >
        <div class="input-group mb-3">
          <input
            class="form-control"
            id="item-url"
            type="text"
            readonly
            [value]="shareUrl"
            #inputTarget
          />
          <ng-container>
            <button
              class="btn btn-default"
              type="button"
              [tooltip]="copyStatusTemplate"
              container="body"
              triggers="mouseenter:mouseleave"
              [ngxClipboard]="inputTarget"
              (cbOnSuccess)="setCopied()"
              i18n-aria-label="@@shareSheet-btn-copyLink"
              aria-label="Copy item URL"
            >
              <i class="fas fa-clipboard" aria-hidden="true"></i>
            </button>
          </ng-container>
          <ng-template #copyStatusTemplate>
            <ng-container [ngSwitch]="copyStatus">
              <ng-container *ngSwitchCase="true" i18n="@@shareSheet-btn-copied"
                >Copied!</ng-container
              >
              <ng-container *ngSwitchDefault i18n="@@shareSheet-btn-copy"
                >Copy</ng-container
              >
            </ng-container>
          </ng-template>
        </div>

        <article class="c-list-item c-list-item--preview">
          <ng-container *ngIf="state?.resourceImage">
            <img
              alt=""
              class="c-list-item__thumbnail disabled"
              [src]="state.resourceImage"
            />
          </ng-container>

          <div class="c-list-item__content">
            <div
              *ngIf="state?.currentItem?.resource"
              class="c-list-item__content--info"
            >
              <div class="c-list-item__meta">
                <rl-fielded-resource [resource]="state.currentItem.resource">
                </rl-fielded-resource>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default qa-close-button"
          i18n="@@listItem-shareModal-btn-close"
          (click)="onHideShareSheet()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
